(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('UserTypeController', UserTypeController);

    /* @ngInject */
    function UserTypeController(userTypeService, userCategoryService,
        $uibModal, logger, $q, dialogService) {
        var vm = this;
        vm.isLoading = true;

        var modalOptions = userTypeService.getModalOptions();

        vm.userTypes = [];
        vm.userCategories = [];
        vm.addUserType = addUserType;

        activate();

        function activate() {
            var promises = [getUserCategories()];
            return $q.all(promises).then(function () {
                vm.tableConfig = configureTableActions();
                vm.getUserTypes = userTypeService.getUserTypes;
                vm.isLoading = false;
            });

        }

        function getUserCategories() {
            return userCategoryService.getUserCategories().then(function (results) {
                if (results) {
                    vm.userCategories = results;
                } else {
                    vm.userCategories = [];
                }
            });
        }

        function editUserType(userType) {
            modalOptions.controller = 'UserTypeEditController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    userType: function () {
                        return angular.copy(userType);
                    }
                }
            }, modalOptions));

            modalInstance.result.then(function (updatedUserType) {
                angular.extend(userType, updatedUserType);
            }, function () {
                logger.info('Modal dismissed at: ' + new Date());
            });
        }

        function addUserType() {
            modalOptions.controller = 'UserTypeAddController';
            var modalInstance = $uibModal.open(modalOptions);

            modalInstance.result.then(function (newUserType) {
                vm.isLoading = false;
                vm.userTypes.unshift(newUserType);
            }, function () {
                logger.info('Modal dismissed at: ' + new Date());
            });
        }

        function deactivateUserType(userType) {
            dialogService.confirm('Deactivate User Type',
                'Are you sure you want to deactivate this user type?')
                .then(function () {
                    return userTypeService.deactivateUserType(userType.UserTypeId);
                }).then(function (result) {
                    userType.Active = !userType.Active;
                });
        }

        function activateUserType(userType) {
            dialogService.confirm('Activate User Type',
                'Are you sure you want to activate this user type?')
                .then(function () {
                    return userTypeService.activateUserType(userType.UserTypeId);
                }).then(function (result) {
                    userType.Active = !userType.Active;
                });
        }

        function setActiveStatus(userType) {
            if (userType.Active) {
                deactivateUserType(userType);
            } else {
                activateUserType(userType);
            }
        }

        function syncApplicationRoles(userType) {
            dialogService.confirm('Sync Application Roles',
                'You have selected to sync application roles for ' + userType.UserTypeName + '.' +
                ' This will override all application roles for users that are linked to this user type.' +
                ' Are you sure that you want to proceed?')
                .then(function () {                    
                    return userTypeService.syncApplicationRoles(userType.UserTypeId);
                }).then(function (result) {

                    dialogService.info('Success', 'All applications and roles for users linked to  ' +
                        userType.UserTypeName + ' have been successfully synced');

                });
        }

        function hideSyncButtonWhenNotActive(userType) {
            return userType.Active;
        }

        function configureTableActions() {
            var tableConfig = userTypeService.getTableConfig(vm.userCategories);
            tableConfig.actions = [
                {
                    name: '"Edit"',
                    action: editUserType,
                    icon: '"fa-edit"',
                    permission: ['SSO:SysAdmin']
                },
                {
                    name: '"Sync Application Roles"',
                    action: syncApplicationRoles,
                    icon: '"fa-refresh"',
                    permission: ['SSO:SysAdmin'],
                    filterDropDown: hideSyncButtonWhenNotActive
                },
                {
                    name: 'row.Active ? "Deactivate" : "Activate"',
                    action: setActiveStatus,
                    icon: 'row.Active ? "fa-minus-circle" : "fa-plus-circle"',
                    permission: ['SSO:SysAdmin']
                }];
            return tableConfig;
        }
    }
})();
